export var InterestBounceType;
(function (InterestBounceType) {
    InterestBounceType["NORMAL"] = "NORMAL";
    InterestBounceType["DATE_BREACHED"] = "DATE_BREACHED";
    InterestBounceType["HARD_DATE_BREACHED"] = "HARD_DATE_BREACHED";
    InterestBounceType["BOUNCED"] = "BOUNCED";
})(InterestBounceType || (InterestBounceType = {}));
